import classNames from 'classnames';
import {useCallback} from 'react';

import {Icon} from 'components/UIKit/Icon';

type Props = {
    checked: boolean;
    name: string;
    size?: 'normal' | 'small'
    label?: string;
    labelPlacement?: 'left' | 'right';
    inline?: boolean;
    disabled?: boolean;
    className?: string;
    indeterminate?: boolean;
    fullWidth?: boolean;
    onChange?: (value: boolean) => void;
}
export type CheckboxProps = Props;

export const Checkbox: React.FC<Props> = ({
    checked, name, label, size = 'normal', labelPlacement = 'left',
    inline, disabled, className, indeterminate, fullWidth, onChange
}: Props) => {
    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.checked);
    }, [onChange]);

    return (
        <label
            htmlFor={name}
            className={classNames(className, 'vs-checkbox tw-relative tw-items-center tw-cursor-pointer',
                inline ? 'tw-inline-flex' : 'tw-flex',
                {
                    'tw-text-default-dimmed': disabled,
                    'tw-justify-between tw-w-full': fullWidth
                })}
        >
            <input
                id={name}
                disabled={disabled}
                type='checkbox'
                className='tw-absolute tw-opacity-0 tw-pointer-events-none'
                checked={checked}
                onChange={handleChange}
            />
            <span className={classNames('tw-flex-center tw-border', {
                'tw-bg-primary tw-border-primary': checked || indeterminate,
                'tw-border-dark': !checked && !disabled,
                'tw-bg-default tw-border-default': disabled,
                'tw-order-2': labelPlacement === 'right',
                'tw-w-3 tw-h-3 tw-rounded-sm': size === 'small',
                'tw-w-6 tw-h-6 tw-rounded': size === 'normal',
            })}
            >
                {indeterminate ? <Icon
                    name='minus'
                    color='light'
                    size={size === 'small' ? 'xs' : 'lg'}
                    className='tw-opacity-1'
                /> : <Icon
                    name='check'
                    color='light'
                    size={size === 'small' ? 'xs' : 'lg'}
                    className={checked ? 'tw-opacity-1' : 'tw-opacity-0'}
                />}

            </span>
            {label && (
                <span className={labelPlacement === 'right' ? 'tw-mr-2' : 'tw-ml-2'}>
                    {label}
                </span>
            )}
        </label>
    );
};